export default "__VITE_PUBLIC_ASSET__89f5b385__"